import { ValidatorFn, Validators, AbstractControl, FormArray } from '@angular/forms';
import { Observable, zip } from 'rxjs';
import { map } from 'rxjs/operators';
import { TranslationService } from '@cemex-core/angular-localization-v7';
import { PaymentHeader } from '@cemex-core/types-v1';

import { AbstractPaymentEngine } from './abstract-payment-engine';
import { NumberValidators } from './../../../cemexcomponents/helpers/v1';
import { PaymentConfiguration } from '../models/payment-configuration';
import { PaymentEngineConfiguration } from './payment-engine-configuration';
import { PaymentRequest } from './../models/payment-request';
import { PayerBrokerRequest } from './../models/payer-broker-request';
import { PayerBrokerResponse } from './../models/payer-broker-response';
import { JPMPayerBrokerResponse } from './../models/jpm-payer-broker-response';
import { PaymentProcessActions } from './../store/actions/payment-process.action';

export class PaymentEngineUS extends AbstractPaymentEngine {

    constructor(configuration: PaymentEngineConfiguration, t: TranslationService) {
        super(configuration, t);
    }

    getPaymentConfiguration(): Observable<PaymentConfiguration> {
        return zip(
            super.initPaymentConfiguration(),
            this.bankService.getBankList({
                companyCode: this.company.companyCode,
                countryCode: this.customer.countryCode,
                customerCode: this.customer.customerCode
            })
        ).pipe(
            map(([paymentConfiguration, banks]) => {
                banks.forEach(bank => bank.bankCode = bank.shortID4HouseBank);
                paymentConfiguration.paymentMethods.forEach((pm) => {
                    pm.transCode = this.getTransCode(pm.code);
                    pm.paymentNetworks = banks;

                });

                return paymentConfiguration;
            })
        );
    }

    getAmountValidators(isDebit: boolean, expectedPayment: number): ValidatorFn | ValidatorFn[] {
        if (isDebit) {
            return super.getAmountValidators(isDebit, expectedPayment);
        } else {
            return [Validators.required,
                NumberValidators.isNumeric, NumberValidators.onlyTwoDecimals,
                NumberValidators.greaterThan(expectedPayment)];
        }
    }

    getDocumentsValidators(): ValidatorFn | ValidatorFn[] {
        return (control: AbstractControl): { [key: string]: any } => {
            let payment = 0;
            let hasCredits = false;
            (control as FormArray).controls.forEach(c => {
                hasCredits = hasCredits || !c.get('debitFlag').value;
                payment += c.get('payment').value;
            });

            return hasCredits && payment < 1 ? { amountWithCreditInvalid: true}  : null;
        };
    }

    getBanks(): any { }

    createReference(request: PaymentRequest): Observable<any> {
        return this.paymentService.createReferenceV2(request).pipe(
            map(response => {
                this.store.dispatch(new PaymentProcessActions.GetPayerInfomationSuccess(response.parameters));

                return response.headerOut[0];
            })
        );
    }

    getPayerBroker(request: PayerBrokerRequest, brokerCode: string): Observable<any> {
        return this.paymentService.getPayerInformation(request);
    }

    callToNetworking(totalToPay: string, referenceCode: string, payerInformation: JPMPayerBrokerResponse): void {
        const action = payerInformation.sessionTransferUrl;
        this.createFormRequestNetwork(action, 'GET', '_self');
    }

    private getTransCode(paymentCode: string): string {
        let transCode = '';

        switch (paymentCode) {
            case 'TRANSFER':
                transCode = 'transfer';
                break;
            case 'CREDIT':
                transCode = 'creditcard';
                break;
            case 'REFERENCE':
                transCode = 'reference';
                break;
            default:
                transCode = paymentCode.toLowerCase();
        }

        return transCode;
    }

    saveExternalOrderRelation(): any {
        throw new Error('Method not implemented.');
    }

    getHeaderPayerInformation(request: any, payerInformationResponse: any, storeDataInfo: any): any {
        throw new Error('Method not implemented.');
    }

}
